import { StrictMode } from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import CspHeader from './components/Header/CspHeader';
import reportWebVitals from './reportWebVitals';

const rootElement = document.getElementById('root');

ReactDOM.render(
  <StrictMode>
    <CspHeader />
    <App />
  </StrictMode>,
  rootElement
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
